import React, { useState, useEffect } from 'react';
import Layout from "../../components/Layout/Layout";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import BeatLoader from "react-spinners/BeatLoader";
import moment from 'moment';
import { db } from "../../firebase/firebase-config";
import { Table, Input, Select } from 'antd';
import { MdOutlineCancelPresentation } from "react-icons/md";
import { AiOutlineCheckSquare } from "react-icons/ai";

import { CreeateSpecialityModal, ConfirmModal } from '../../components';

import { collection, query, where, getDocs, doc, updateDoc, deleteDoc } from "firebase/firestore";

import { FiEdit } from 'react-icons/fi';
import { BsFillTrashFill } from 'react-icons/bs';

const { Search } = Input;

const override = {
  marginTop: "20px",
};

function Specialities() {
    const [specialityData, setSpecialityData] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [searchText, setSearchText] = useState<string>('');
    const [filteredData, setFilteredData] = useState<any[]>(specialityData);
  
    const [showConfirmodal, setShowConfirmModal] = useState(false);
    const [showConfirmActivateModal, setShowConfirmActivateModal]  = useState(false);
    const [currentActiveId, setCurrentActiveId] = useState(null);
  
    const [showDoctorDetailsModal, setShowDoctorDetailsModal] = useState(false);
    const [activeUserData, setActiveUserData] = useState(null);
  
    const [loading, setLoading] = useState(false);


    const toggleAddModal = async () => {
        // fetchUsers().then(doc => console.log(doc.data()))
        setShowCreateModal(!showCreateModal);
      };
    

      const rows: any = [
        {
          title: "#",
          dataIndex: "index",
          key: "index",
          render: (text: any, record: any, index: number) => index + 1,
        },
        {
          title: "Speciality Name",
          dataIndex: "speciality_name",
          key: "speciality_name",
          sorter: (a: any, b: any) => a.username.localeCompare(b.username),
        },
        {
            title: "Date Created",
            dataIndex: "createdAt",
            key: "createdAt",
            sorter: (a: any, b: any) => a.createdAt.localeCompare(b.createdAt),
            render: (createdAt: any) => (createdAt ? moment(new Date(createdAt.seconds * 1000)).format('MMMM D, YYYY') : '--'),
          },
        {
          title: "Action",
          dataIndex: "action",
          key: "action",
          render: (text: any, record: any) => (
            <td className="flex-center">
              <div className="action">
                  <Tippy content="Edit" animation="fade">
                    <a
                      className="see"
                      onClick={() => {
                        // Add your logic here when Activate button is clicked
                        
                        setActiveUserData(record);
                        setShowDoctorDetailsModal(true)
                      }}
                    >
                    <FiEdit
                      style={{
                        color: "white",
                      }}
                       size={18} />
                    </a>
                  </Tippy>
      
                  <Tippy content="Delete" animation="fade">
                    <a
                      onClick={() => {
                        setCurrentActiveId(record.id);
                        setShowConfirmModal(true);
                      }}
                      className="delete"
                    >
                      <BsFillTrashFill size={18} />
                    </a>
                  </Tippy>
      
               
              </div>
            </td>
          ),
      
        },
    
      ];
      
    
      const fetchData = async () => {
        setLoading(true);
    
        const specialities = await getDocs(collection(db, "Specialities"));
    
        const res: any = [];

        specialities.forEach((speciality) => {

          res.push({
            id: speciality.id,
            ...speciality.data(),
          });
        });
    
        setSpecialityData(res);

        // console.log('DATA: ', res); 
        setLoading(false);
      };
    
      async function deleteSpeciality(specialityId: any) {
        // LOGIC TO DELETE SPECIALITY
        const docRef = doc(collection(db,"Specialities"),specialityId)
    
        if(specialityId != null) {
           await deleteDoc(docRef).then(() => {
              fetchData();
              setShowConfirmModal(false);
            })
        }
      }
    
      async function activatedAccount(doctorId: any) {
        // LOGIC TO SUSPEND ACCOUNT
        const docRef = doc(collection(db,"users"),doctorId)
    
        // console.log('SUSPEND: ', currentActiveId);
        
        if(doctorId != null) {
           await updateDoc(docRef, {
                  status: true
            }).then(() => {
              fetchData();
              setShowConfirmActivateModal(false);
            });
        }
      }
    
      useEffect(() => {
        fetchData();
      }, []);
    
      const [sortedInfo, setSortedInfo] = useState<any>({});
    
      const handleChange = (pagination: any, filters: any, sorter: any) => {
        setSortedInfo(sorter);
      };
    
      specialityData.forEach((item: any, index: any) => {
        item.index = index + 1;
      });
    
      useEffect(() => {
        setFilteredData(filterData(specialityData, searchText));
      }, [specialityData, searchText]);
    
      const filterData = (data: any[], query: string) => {
        if (!query) return data;
    
        return data.filter((item) =>
          Object.values(item).some((value: any) =>
            value.toString().toLowerCase().includes(query.toLowerCase())
          )
        );
      };
    
    
      const handleSearch = (value: string) => {
        setSearchText(value);
      };

    return (
        <Layout title="Doctor Specialities" pageTitle="Doctor-Specialities">
        <div className="section">
          <div className="parent-con">
            <div className="data-table">
              <div className="top">
                <div className="span">
                  <h3>All Specialities</h3>
                </div>

                <button
                  onClick={toggleAddModal}
                  className="btn btn-primary btn-add student-button"
                >
                  {" "}
                  Add New Speciality{" "}
                </button>
              </div>
              <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder="Search for data..."
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                <Table
                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}
                  columns={rows}
                  onChange={handleChange}
                  rowKey="speciality_name"
                  showSorterTooltip={false}
                  pagination={{ pageSize: 10 }}
                />
              </div>
            </div>
          </div>
        </div>

        {
            showCreateModal &&  <CreeateSpecialityModal onContentAdded={()=>fetchData()} onClose={toggleAddModal} />
        }
        {showConfirmodal && (
            <ConfirmModal 
                title="Are you sure you want to delete speciality ?"
                onAccept={() => deleteSpeciality(currentActiveId)}
                onCancel={() => setShowConfirmModal(false)}
            />
        )}
        </Layout>
    );
}

export default Specialities;